import React, { Component } from "react";
import { observer } from "mobx-react";

import { QuizObjectFact } from "../../../../../../store/modquiz/quiz_objects/quiz-object";

import FactTable from "./FactTable";

interface MyProps {
    addFact: (
        event?:
            | React.MouseEvent<Element, MouseEvent>
            | React.KeyboardEvent<Element>
    ) => void;
    deleteFact: Function;
    undeleteFact: Function;
    setFacts: Function;
    updateFact: Function;
    focusField: Function;
    blurField: (event: React.FocusEvent<HTMLInputElement>) => void;
    facts: Array<QuizObjectFact>;
}

class QuizObjectFacts extends Component<MyProps, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            updater: 1
        };
    }

    handleFactTableUpdate(evt: any, factID: string, factOrder: number) {
        var component = this;
        var facts = this.props.facts.slice();
        let nameValue;

        var newFacts = facts.map(function(fact: QuizObjectFact) {
            if (factID) {
                if (evt.target.name == `name-${factID}` && fact._id == factID) {
                    component.props.updateFact(
                        factID,
                        factOrder,
                        "name",
                        evt.target.value
                    );
                    fact.name = evt.target.value;
                }

                if (
                    evt.target.name == `value-${factID}` &&
                    fact._id == factID
                ) {
                    component.props.updateFact(
                        factID,
                        factOrder,
                        "value",
                        evt.target.value
                    );
                    fact.value = evt.target.value;
                }
            } else {
                /*
                 * This will catch new facts
                 */
                if (
                    evt.target.name == `name-${factID}` &&
                    fact.order == factOrder
                ) {
                    component.props.updateFact(
                        factID,
                        factOrder,
                        "name",
                        evt.target.value
                    );
                    fact.name = evt.target.value;
                }

                if (
                    evt.target.name == `value-${factID}` &&
                    fact.order == factOrder
                ) {
                    component.props.updateFact(
                        factID,
                        factOrder,
                        "value",
                        evt.target.value
                    );
                    fact.value = evt.target.value;
                }
            }

            return fact;
        });

        // this.props.setFacts(newFacts);
    }

    render() {
        return (
            <FactTable
                onFactTableUpdate={this.handleFactTableUpdate.bind(this)}
                onRowAdd={this.props.addFact}
                onRowDel={this.props.deleteFact}
                onRowUndel={this.props.undeleteFact}
                focusField={this.props.focusField}
                blurField={this.props.blurField}
                facts={this.props.facts}
            />
        );
    }
}

export default observer(QuizObjectFacts);
